<template>
  <div
    class="overlay"
    @click.self="$emit('fechar')"
  >
    <div class="modal-filtros">
      <div class="modal-header">
        <span>Filtros Tarefas</span>
        <button
          class="btn-fechar"
          @click="$emit('fechar')"
        >
          ✕
        </button>
      </div>

      <div class="modal-corpo">
        <!-- Abrangência -->
        <div class="coluna">
          <p class="coluna-titulo">Tarefas Gerais:</p>
          <label
            v-for="op in tarefasGerais"
            :key="op.value"
          >
            <input
              type="checkbox"
              v-model="filtros.abrangencia"
              :value="op.value"
            />
            {{ op.label }}
          </label>
        </div>

        <!-- Data -->
        <div class="coluna">
          <p class="coluna-titulo">Ordem:</p>
          <label
            v-for="op in ordem"
            :key="op.value"
          >
            <input
              type="checkbox"
              v-model="filtros.data"
              :value="op.value"
            />
            {{ op.label }}
          </label>
        </div>

        <!-- Ação -->
        <div class="coluna">
          <p class="coluna-titulo">Estado da tarefa:</p>
          <label
            v-for="op in estado"
            :key="op.value"
          >
            <input
              type="checkbox"
              v-model="filtros.acao"
              :value="op.value"
            />
            {{ op.label }}
          </label>
        </div>
      </div>

      <div class="modal-rodape">
        <button
          class="btn-limpar"
          @click="limparFiltros"
        >
          Limpar filtros
        </button>
        <button
          class="btn-filtrar"
          @click="aplicarFiltros"
        >
          Filtrar
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

const emit = defineEmits(["fechar", "aplicarFiltros"]);

const tarefasGerais = [
  {
    label: "TAREFAS_RELACIONADAS_A_ATIVIDADES",
    value: "Tarefas relacionadas à atividade",
  },
];

const ordem = [
  { label: "A - Z", value: " A - Z" },
  { label: "Z - A", value: "Z - A" },
  { label: "MAIS_RECENTE", value: "Mais recente" },
  { label: "MAIS_ANTIGA", value: "Mais antiga" },
];

const estado = [
  { label: "PARA_FAZER", value: "Para fazer" },
  { label: "EM_ANDAMENTO", value: "Em andamento" },
  { label: "CANCELADA", value: "Cancelada" },
  { label: "CONCLUIDA", value: "Concluída" },
];

const filtros = ref({
  abrangencia: [],
  data: [],
  acao: [],
});

function limparFiltros() {
  filtros.value = { abrangencia: [], data: [], acao: [] };
}

function aplicarFiltros() {
  emit("aplicarFiltros", filtros.value);
  emit("fechar");
}
</script>

<style scoped>
.overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-filtros {
  background: var(--branco);
  border-radius: 12px;
  width: max-content;
  overflow: hidden;
  box-shadow: 0 8px 32px var(--preto);
}

.modal-header {
  background: var(--roxo-escuro2);
  color: var(--branco);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 14px 20px;
  font-size: 1rem;
  font-weight: 600;
  position: relative;
}

.btn-fechar {
  position: absolute;
  right: 14px;
  background: transparent;
  border: 2px solid var(--branco);
  color: var(--branco);
  border-radius: 6px;
  width: 28px;
  height: 28px;
  cursor: pointer;
  font-size: 0.85rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-corpo {
  display: flex;
  justify-content: space-around;
  gap: 50px;
  padding: 28px 20px;
  background: var(--branco);
}

.coluna {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.coluna-titulo {
  font-weight: 700;
  font-size: 0.95rem;
  color: var(--preto);
  margin-bottom: 4px;
}

label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.88rem;
  color: var(--preto);
  cursor: pointer;
}

input[type="checkbox"] {
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: var(--roxo-escuro2);
}

.modal-rodape {
  display: flex;
  justify-content: center;
  gap: 16px;
  padding: 20px;
  background: var(--branco);
}

.btn-limpar {
  border: 2px solid var(--roxo-claro);
  background: var(--branco);
  color: var(--roxo-claro);
  border-radius: 10px;
  padding: 8px 28px;
  font-weight: 600;
  cursor: pointer;
  font-size: 0.9rem;
}

.btn-filtrar {
  background: var(--roxo-claro);
  color: var(--branco);
  border: none;
  border-radius: 10px;
  padding: 8px 28px;
  font-weight: 600;
  cursor: pointer;
  font-size: 0.9rem;
}
</style>
